import { useQuery } from '@tanstack/react-query';
import { CALENDAR_EVENTS_QUERY } from '../graphql/queries';
import { gql } from '../lib/api';

export interface CalendarEvent {
  storeId: string;
  date: string;
  title: string;
  updatedAt: string;
}

export const useCalendarEvents = (from: string | undefined, to: string | undefined) => useQuery({
  enabled: !!from && !!to,
  queryKey: ['calendarEvents', from, to],
  queryFn: () => gql<{ calendarEvents: CalendarEvent[] }>(CALENDAR_EVENTS_QUERY, { from, to }),
});

export const eventFor = (events: CalendarEvent[] | undefined, storeId: string, date: string): CalendarEvent | undefined =>
  events?.find((event) => event.storeId === storeId && event.date === date);
